import { render, staticRenderFns } from "./preAlertDetail.vue?vue&type=template&id=63596479&scoped=true"
import script from "./preAlertDetail.vue?vue&type=script&lang=js"
export * from "./preAlertDetail.vue?vue&type=script&lang=js"
import style0 from "./preAlertDetail.vue?vue&type=style&index=0&id=63596479&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63596479",
  null
  
)

export default component.exports